import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InfoIcon from '@mui/icons-material/Info';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import WarningIcon from '@mui/icons-material/Warning';
import { Chip } from '@mui/material';
import type { JSX } from 'react';
import type { Priority } from '../api/types';
import { priorityChip } from '../theme';

const ICONS: Record<Priority, JSX.Element> = {
  hoch: <PriorityHighIcon />,
  mittel: <WarningIcon />,
  niedrig: <ArrowDownwardIcon />,
  info: <InfoIcon />,
};

/** BR-8: Priorität ist nie nur Farbe -- immer Icon + Text. */
export function PriorityChip({ priority }: { readonly priority: Priority }): JSX.Element {
  const spec = priorityChip[priority];
  return (
    <Chip
      data-testid={`priority-chip-${priority}`}
      icon={ICONS[priority]}
      label={spec.text}
      size="small"
      sx={{ color: spec.fg, backgroundColor: spec.bg, borderColor: spec.border }}
      variant="outlined"
    />
  );
}
